import { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import yup from 'utils/yup';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { UserRegisterRepository } from 'interfaceAdapter/repositories/UserRegister';
import { useLoading } from 'application/contexts/useLoading';

const schema = yup
    .object({
        email: yup.string().default('').required().email(),
        agreed: yup.boolean().default(false).oneOf([true], '利用規約に同意してください').required(),
        privacyAgreed: yup.boolean().default(false).oneOf([true], 'プライバシーポリシーに同意してください').required(),
        cookieAgreed: yup.boolean().default(false).oneOf([true], 'Cookie利用に同意してください').required(),
    })
    .required();

type SendEmailForm = yup.InferType<typeof schema>;

export const useSendRegistrationMailForBuyer = () => {
    const diContainer = useContext(diContainerContext);
    const userRegisterRepository = diContainer.resolve(UserRegisterRepository);
    const { loading, setLoading } = useLoading();
    const navigate = useNavigate();

    const {
        control,
        handleSubmit,
        formState: { errors },
        getValues,
    } = useForm<SendEmailForm>({
        resolver: yupResolver(schema),
        mode: 'onChange',
        defaultValues: {
            email: '',
            agreed: false,
            privacyAgreed: false,
            cookieAgreed: false,
        },
    });

    const sendMail = handleSubmit(async ({ email }) => {
        setLoading(true);
        try {
            await userRegisterRepository.sendBuyerRegistrationEmail(email);
            navigate('/buyer/send-registration-mail/complete/');
        } finally {
            setLoading(false);
        }
    });

    return {
        control,
        errors,
        loading,
        sendMail,
        getValues,
    };
};
